import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export const JFX_PRESET = definePreset(Lara, {
  primitive: {
    borderRadius: {
      none: '0',
      xs: '2px',
      sm: '4px',
      md: '6px',
      lg: '6px',
      xl: '6px',
    },
  },
  semantic: {
    primary: {
      50: '#fef2f4',
      100: '#fde6ea',
      200: '#fac8d0',
      300: '#f59aaa',
      400: '#ee5f76',
      500: '#DA1A35',
      600: '#c01730',
      700: '#a21328',
      800: '#871127',
      900: '#731125',
      950: '#40050f',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#F7D21E',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
      },
    },
    overlay: {
      modal: {
        borderRadius: '6px',
      },
    },
  },
  components: {
    card: {
      root: {
        borderRadius: '6px',
        shadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
      },
    },
    button: {
      colorScheme: {
        light: {
          root: {
            contrast: {
              background: '#DA1A35',
              borderColor: '#DA1A35',
              hoverBackground: '#c01730',
              hoverBorderColor: '#c01730',
              activeBackground: '#a21328',
              activeBorderColor: '#a21328',
              color: '#F7D21E',
              hoverColor: '#F7D21E',
              activeColor: '#F7D21E',
            },
          },
        },
      },
    },
  },
});
